 if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  function getAppendTarget() {
    const blogGrid = document.getElementById('blog-grid');
    if (blogGrid) return blogGrid;
    return document.getElementById('items-grid');
  }

  function getItemsGridEl() {
    return document.getElementById('items-grid');
  }

  function renderPaginationButton(sectionId, html) {
    const destination = document.getElementById('btn-pagination-' + sectionId);
    const source = html.getElementById('btn-pagination-' + sectionId);
    if (destination && source) {
      destination.innerHTML = source.innerHTML;
    }
  }

  function buildPageUrl(pageNum) {
    const u = new URL(window.location.href);
    u.searchParams.set('page', String(pageNum));
    return u.toString();
  }

  function getPageFromUrl() {
    const raw = new URL(window.location.href).searchParams.get('page');
    if (!raw) return 1;
    const n = parseInt(raw, 10);
    return Number.isNaN(n) || n < 1 ? 1 : n;
  }

  // gets accurate data based on the page number
  async function accumulatePagesToTarget(targetPage, sectionId) {
    const itemsGrid = getItemsGridEl();
    if (!itemsGrid || !sectionId) return;

    if (targetPage < 2) {
      try {
        const r1 = await fetch(buildPageUrl(1));
        const html1 = await r1.text();
        const doc1 = new DOMParser().parseFromString(html1, 'text/html');
        const newItemsGrid = doc1.getElementById('items-grid');
        if (!newItemsGrid) return;
        itemsGrid.innerHTML = newItemsGrid.innerHTML;
        renderPaginationButton(sectionId, doc1);
        itemsGrid.classList.remove('opacity-0');
      } catch (e) {
        console.error(e);
        itemsGrid.classList.remove('opacity-0');
      }
      return;
    }

    try {
      const r1 = await fetch(buildPageUrl(1));
      const html1 = await r1.text();
      const doc1 = new DOMParser().parseFromString(html1, 'text/html');
      const newItemsGrid = doc1.getElementById('items-grid');
      if (!newItemsGrid || !itemsGrid.parentNode) return;

      itemsGrid.innerHTML = newItemsGrid.innerHTML;

      const appendTarget = getAppendTarget();
      if (!appendTarget) return;

      for (let p = 2; p <= targetPage; p++) {
        const rp = await fetch(buildPageUrl(p));
        const htmlp = await rp.text();
        const docp = new DOMParser().parseFromString(htmlp, 'text/html');
        const productGrid = docp.getElementById('items-grid');
        const newProducts = productGrid ? productGrid.getElementsByClassName('grid-item') : [];
        for (let i = 0; i < newProducts.length; i++) {
          appendTarget.insertAdjacentHTML('beforeend', newProducts[i].innerHTML);
        }
        if (p === targetPage) {
          renderPaginationButton(sectionId, docp);
        }
      }

      itemsGrid.classList.remove('opacity-0');
    } catch (e) {
      console.error(e);
      itemsGrid.classList.remove('opacity-0');
    }
  }

  async function accumulatePagesOnLoad() {
    const itemsGrid = getItemsGridEl();
    if (!itemsGrid || !itemsGrid.dataset.accumulatePage) return;
    const targetPage = parseInt(itemsGrid.dataset.accumulatePage, 10);
    const sectionId = itemsGrid.dataset.sectionId;
    if (!sectionId || Number.isNaN(targetPage) || targetPage < 2) return;
    await accumulatePagesToTarget(targetPage, sectionId);
  }

  function onHistoryPopstate() {
    const itemsGrid = getItemsGridEl();
    if (!itemsGrid || !itemsGrid.dataset.sectionId) return;
    const sectionId = itemsGrid.dataset.sectionId;
    const targetPage = getPageFromUrl();
    accumulatePagesToTarget(targetPage, sectionId);
  }

  document.addEventListener('DOMContentLoaded', () => {
    accumulatePagesOnLoad();
  });

  // to handle the back button on browsers
  window.addEventListener('popstate', onHistoryPopstate);

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xPagination', (sectionId, pushUrlAfterAppend) => ({
        loading: false,
        loadData(url) {
          this.loading = true;
          fetch(url)
          .then(response => response.text())
          .then(response => {
              const parser = new DOMParser();
              const html = parser.parseFromString(response,'text/html');
              const productGrid = html.getElementById('items-grid');
              const newProducts = productGrid ? productGrid.getElementsByClassName('grid-item') : [];
              let productsOnPage = getAppendTarget();
              if (!productsOnPage || newProducts.length === 0) {
                return;
              }
              if (pushUrlAfterAppend && url) {
                try {
                  const u = new URL(url, window.location.origin);
                  history.pushState(null, '', u.pathname + u.search + u.hash);
                } catch (e) {
                  console.error(e);
                }
              }
              for (let i = 0; i < newProducts.length; i++) {
                setTimeout(() => {
                  productsOnPage.insertAdjacentHTML('beforeend', newProducts[i].innerHTML);
                  if (i === newProducts.length - 1) {
                    renderPaginationButton(sectionId, html);
                  }
              }, i*300);
              }
            })
          .catch(e => {
              console.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        },
      }));
    });
  });
}
